import { render, staticRenderFns } from "./OAClients.vue?vue&type=template&id=6e1ada2a"
import script from "./OAClients.vue?vue&type=script&lang=ts"
export * from "./OAClients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports